import React from 'react'
import { graphql, Link } from 'gatsby'

import Layout from '../components/Layout'
import Seo from '../components/Seo'
import ShareLinks from '../components/ShareLinks'
import AboutAuthor from '../components/AboutAuthor'
import PrevNext from '../components/PrevNext'
import kebabCase from '../utils/kebabCase'

class BlogPostTemplate extends React.Component {
	render() {
		const post = this.props.data.markdownRemark
		const siteTitle = this.props.data.site.siteMetadata.title
		const siteUrl = this.props.data.site.siteMetadata.siteUrl
		const { previous, next } = this.props.pageContext

		return (
			<Layout location={this.props.location} title={siteTitle}>
				<Seo
					title={post.frontmatter.title}
					description={post.frontmatter.description || post.excerpt}
				/>
				<div className="inner-wrap-container">
					<div className="inner-wrap visible animate fade-in">
						<div className="single-article">
							{post.frontmatter.thumbnail && (
								<div
									className="featured-image"
									style={{
										backgroundImage: `url(${post.frontmatter.thumbnail.childImageSharp.fluid.src})`,
									}}
								/>
							)}
							<div className="post-content m-auto">
								<div className="tag-wrap">
									{post.frontmatter.tags &&
										post.frontmatter.tags.map(tag => (
											<Link key={tag} to={`/tags/${kebabCase(tag)}`}>
												{tag}
											</Link>
										))}
									<span className="reading-time">
										{post.timeToRead} min read
									</span>{' '}
									<span className="date">{post.frontmatter.date}</span>
								</div>
								<h1 className="title">{post.frontmatter.title}</h1>
								<div
									className="content"
									dangerouslySetInnerHTML={{ __html: post.html }}
								/>
								<ShareLinks
									url={`${siteUrl.slice(0, -1)}${post.fields.slug}`}
									title={post.frontmatter.title}
									siteUrl={siteUrl}
								/>
								<AboutAuthor avatar={this.props.data.avatar} />
								<hr className="small" />
								<PrevNext prev={previous} next={next} />
							</div>
						</div>
					</div>
				</div>
			</Layout>
		)
	}
}

export default BlogPostTemplate

export const pageQuery = graphql`
	query BlogPostBySlug($slug: String!) {
		site {
			siteMetadata {
				title
				author
				siteUrl
			}
		}
		avatar: file(absolutePath: { regex: "/profile-pic./" }) {
			childImageSharp {
				fixed(width: 120, height: 120) {
					...GatsbyImageSharpFixed
				}
			}
		}
		markdownRemark(fields: { slug: { eq: $slug } }) {
			id
			excerpt(pruneLength: 160)
			fields {
				slug
			}
			html
			timeToRead
			frontmatter {
				title
				date(formatString: "MMMM DD, YYYY")
				description
				tags
				thumbnail {
					childImageSharp {
						fluid(maxWidth: 1024) {
							...GatsbyImageSharpFluid
						}
					}
				}
			}
		}
	}
`
